/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface MarkTargetNoteMessagesAsReadByStaff$Params {
  targetId?: number;
}

export function MarkTargetNoteMessagesAsReadByStaff(http: HttpClient, rootUrl: string, params?: MarkTargetNoteMessagesAsReadByStaff$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, MarkTargetNoteMessagesAsReadByStaff.PATH, 'post');
  if (params) {
    rb.query('targetId', params.targetId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

MarkTargetNoteMessagesAsReadByStaff.PATH = '/api/Staff/MarkTargetNoteMessagesAsReadByStaff';
